import { render, staticRenderFns } from "./HomeViewTwo.vue?vue&type=template&id=c6da4e4a&scoped=true"
import script from "./HomeViewTwo.vue?vue&type=script&lang=js"
export * from "./HomeViewTwo.vue?vue&type=script&lang=js"
import style0 from "./HomeViewTwo.vue?vue&type=style&index=0&id=c6da4e4a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6da4e4a",
  null
  
)

export default component.exports